import walterIAApi from '../clients/WalterIAClient'

export default {
	getModels: () => walterIAApi.get('/api/chat/models'),
	getSessions: () => walterIAApi.get('/api/sessions'),
	getMessages: (sessionId) => walterIAApi.get(`/api/sessions/${sessionId}/messages`),
	deleteSession: (sessionId) => walterIAApi.delete(`/api/sessions/${sessionId}`),
	renameSession: (sessionId, title) => walterIAApi.patch(`/api/sessions/${sessionId}`, { title }),
	moveSession: (sessionId, projectId) =>
		walterIAApi.patch(`/api/sessions/${sessionId}`, { projectId: projectId || '' }),
	getProjects: () => walterIAApi.get('/api/projects'),
	createProject: (name, description) => walterIAApi.post('/api/projects', { name, description }),
	updateProject: (id, name, description) =>
		walterIAApi.patch(`/api/projects/${id}`, { name, description }),
	renameProject: (id, name) => walterIAApi.patch(`/api/projects/${id}`, { name }),
	deleteProject: (id) => walterIAApi.delete(`/api/projects/${id}`),
	sendChat: (data) => walterIAApi.post('/api/chat', data),
	streamChat: async (data) => {
		const token = localStorage.getItem('jwt')
		const baseUrl = process.env.VUE_APP_WALTERIA_API || 'https://api-walteria.smartforest.com.br'
		return fetch(`${baseUrl}/api/chat/stream`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: token || '',
			},
			body: JSON.stringify(data),
		})
	},
}
